import { gql } from "_graphql-types/gql";

export const KNOWLEDGE_BASE_LIST_QUERY = gql(`
  query KnowledgeBaseList(
    $filter: KnowledgeBaseFilter
    $sort: [KnowledgeBaseSort!]
    $page: PageInput
  ) {
    knowledgeBaseList(filter: $filter, sort: $sort, page: $page) {
      items {
        id
        entityId
        type
        entity {
          note {
            id
            noteMetaId
            text
            editedText
            noteDate
            createDate
            modifyDate
            createUser
            createUserFullName
            entityAssignments {
              id
              businessObjectTypeEnumId
              entityId
              entityName
            }
          }
          document {
            id
            name
            documentTypeEnumId
            modifyDate
            createUser
            createUserFullName
            extension
            signedUrl
            date
            documentGroupId
            entityAssociations {
              id
              businessObjectTypeEnumId
              entityId
              entityName
            }
            documentTypeEnum {
              id
              name
              description
            }
            documentGroup {
              id
              userName
              commonName
            }
          }
        }
      }
      total
    }
  }
`);

export const SAVE_KNOWLEDGE_BASE_MUTATION = gql(`
  mutation AddSavedKnowledgeBase($input: SavedKnowledgeBaseInput!) {
    addSavedKnowledgeBase(input: $input) {
      id
      userId
      name
      description
      status
      filters
      groupId
      documentCount
      noteCount
      investmentCount
      firmCount
      companyCount
      engagementCount
      errorMessage
      createdAt
      updatedAt
    }
  }
`);

export const SAVED_KNOWLEDGE_BASES_QUERY = gql(`
  query SavedKnowledgeBaseList($filter: SavedKnowledgeBaseFilterInput, $sort: [SavedKnowledgeBaseSort!], $page: PageInput) {
    savedKnowledgeBaseList(filter: $filter, sort: $sort, page: $page) {
      items {
        id
        userId
        name
        description
        status
        filters
        groupId
        documentCount
        noteCount
        investmentCount
        firmCount
        companyCount
        engagementCount
        errorMessage
        createdAt
        updatedAt
      }
      total
    }
  }
`);

export const DELETE_KNOWLEDGE_BASE_MUTATION = gql(`
  mutation DeleteSavedKnowledgeBase($id: Int!) {
    deleteSavedKnowledgeBase(id: $id)
  }
`);

export const UPDATE_KNOWLEDGE_BASE_MUTATION = gql(`
  mutation UpdateSavedKnowledgeBase($id: Int!, $input: SavedKnowledgeBaseInput!) {
    updateSavedKnowledgeBase(id: $id, input: $input) {
      id
      userId
      name
      description
      status
      filters
      groupId
      documentCount
      noteCount
      investmentCount
      firmCount
      companyCount
      engagementCount
      errorMessage
      createdAt
      updatedAt
    }
  }
`);

export const FIND_KNOWLEDGE_BASE_BY_FILTERS_QUERY = gql(`
  query FindSavedKnowledgeBaseByFilters($filters: KnowledgeBaseFilter!) {
    findSavedKnowledgeBaseByFilters(filters: $filters) {
      id
      userId
      name
      description
      status
      filters
      groupId
      documentCount
      noteCount
      investmentCount
      firmCount
      companyCount
      engagementCount
      errorMessage
      createdAt
      updatedAt
    }
  }
`);

export const REMATERIALIZE_KNOWLEDGE_BASE_MUTATION = gql(`
  mutation RematerializeSavedKnowledgeBase($id: Int!) {
    rematerializeSavedKnowledgeBase(id: $id)
  }
`);

export const SAVED_KNOWLEDGE_BASE_QUERY = gql(`
  query SavedKnowledgeBase($id: Int!) {
    savedKnowledgeBase(id: $id) {
      id
      userId
      name
      description
      status
      filters
      groupId
      documentCount
      noteCount
      investmentCount
      firmCount
      companyCount
      engagementCount
      errorMessage
      createdAt
      updatedAt
    }
  }
`);

export const TRIGGER_BATCH_REPORTS_MUTATION = gql(`
  mutation TriggerBatchReports($input: BatchReportsInput!) {
    triggerBatchReports(input: $input) {
      id
    }
  }
`);

export const CURRENT_USER_PRIMARY_ORG_GROUP_ID_QUERY = gql(`
  query CurrentUserPrimaryOrganizationGroupId {
    currentUserPrimaryOrganizationGroupId
  }
`);

export const SEND_LEX_MESSAGE = gql(/* GraphQL */ `
  mutation LexSendMessage(
    $sessionId: String!
    $requestId: String!
    $text: String!
    $conversationId: Int
    $sessionAttributes: JSONObject
  ) {
    lexSendMessage(
      input: {
        sessionId: $sessionId
        requestId: $requestId
        text: $text
        sessionAttributes: $sessionAttributes
        conversationId: $conversationId
      }
    ) {
      conversationId
    }
  }
`);

export const CHAT_MESSAGE_SUBSCRIPTION = gql(/* GraphQL */ `
  subscription ChatMessageSubscription($sessionId: String!) {
    chatMessages(sessionId: $sessionId) {
      sessionId
      requestId
      error
      messageStream {
        message
        messageIndex
        contentType
        blockIndex
        event
        id
      }
    }
  }
`);
